import React, { Component } from "react";

class CountryDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      selected: null,
      searchTerm: "",
    };
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({
      selected: this.props.value
        ? this.props.options.find((opt) => opt.id === this.props.value || opt.id === this.props.value.id) || null
        : null,
    });
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    this.setState({
      selected: this.props.value
        ? this.props.options.find((opt) => opt.id === this.props.value || opt.id === this.props.value.id) || null
        : null,
    });
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  toggleDropdown = () => {
    this.setState((prev) => ({
      isOpen: !prev.isOpen,
      searchTerm: "", // reset search when opened
    }));
  };

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleSelect = (option) => {
    this.setState({
      selected: option,
      isOpen: false,
    });
    this.props.onChange?.(option);
  };

  render() {
    const {
      label = "Select Option",
      name = "dropdown",
      options = [],
      placeholder = "Select...",
      searchPlaceholder = "Search...",
      styles = {},
      required,
      showSearch = true,
      error, value
    } = this.props;

    const { isOpen, selected, searchTerm } = this.state;

    const filteredOptions = options.filter((option) =>
      option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
      <div className={`${styles.custom_dropdown} `} ref={this.wrapperRef}>
        <label htmlFor={name}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>

        <div
          className={`${styles.dropdown_select} ${error ? styles.select_error_border : ""
            }`}
          onClick={this.toggleDropdown}
        >
          <span className={selected || value.label ? "" : styles.slected}>
            {!value ? placeholder : selected ? selected.label : value.label}
          </span>
          <span className={styles.arrow_icon}>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 16.0912L5.80872 9.89997L7.39997 8.30872L12 12.9087L16.6 8.30872L18.1912 9.89997L12 16.0912Z"
                fill="#3F3F46"
              />
            </svg>
          </span>
        </div>

        {isOpen && (
          <div className={styles.dropdown_open}>
            {showSearch && (
              <input
                type="text"
                placeholder={searchPlaceholder}
                value={searchTerm}
                onChange={this.handleSearchChange}
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  border: "none",
                  borderBottom: "1px solid #eee",
                  outline: "none",
                  boxSizing: "border-box",
                  position: "sticky",
                  top: 0,
                }}
              />
            )}

            {filteredOptions.length > 0 ? (
              <ul className={styles.dropdown_list}>
                {filteredOptions.map((option) => (
                  <li
                    key={option.id}
                    onClick={() => this.handleSelect(option)}
                    className={styles.dropdown_option}
                  >
                    <span>{option.label} </span>
                    {option?.code && (
                      <span className={styles.dropdown_option_code}>{option.code ? `${option.code}` : ""}</span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <div style={{ padding: "10px", fontSize: "14px", color: "#888" }}>
                No options found
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default CountryDropdown;
